/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type prospects_CreateProspectCommunicationRequest = {
    channel: prospects_CreateProspectCommunicationRequest.channel;
    direction: prospects_CreateProspectCommunicationRequest.direction;
    /**
     * NextFollowupDate is optional. A supplied value SETS the prospect's follow-up
     * date; an omitted value LEAVES IT UNCHANGED. Clearing it is done from the
     * prospect detail edit form, where an omitted value clears the column like
     * every other nullable prospect field.
     */
    next_followup_date?: string;
    note?: string;
    occurred_at: string;
    outcome: prospects_CreateProspectCommunicationRequest.outcome;
};
export namespace prospects_CreateProspectCommunicationRequest {
    export enum channel {
        PHONE = 'phone',
        EMAIL = 'email',
        WHATSAPP = 'whatsapp',
        SMS = 'sms',
        IN_PERSON = 'in_person',
        WEBSITE = 'website',
    }
    export enum direction {
        OUTBOUND = 'outbound',
        INBOUND = 'inbound',
    }
    export enum outcome {
        INTERESTED = 'interested',
        UNSURE = 'unsure',
        CALLBACK_AGREED = 'callback_agreed',
        TOUR_BOOKED = 'tour_booked',
        NO_INTEREST = 'no_interest',
        NO_ANSWER = 'no_answer',
        OTHER = 'other',
    }
}

